import * as helpers from './helpers';
import * as storage from './storage';

export const FireHelpers = helpers;
export const FireStorage = storage;

export * from './analytics';
export * from './detect';
export * from './component';
export * from './component-record';
export * from './lazy-loader';
export * from './global';